import React from 'react';
import {Checkbox, FormControlLabel} from "@mui/material";
import styles from "./Styles.module.css"

class SelectMultipleCheckbox extends React.Component {
    state = {
        [this.props.orgId] : false
    };

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
        this.props.setValues(name, event.target.checked)
    };

    render() {

        const {checkedItem, checkedItemList, itemName} = this.props;

        return (
            <div className={styles.checkboxWrapper}>
                <FormControlLabel
                    style={{margin: 0}}
                    control={
                        <Checkbox
                            checked={checkedItemList.includes(checkedItem)}
                            onChange={this.handleChange(checkedItem)}
                            sx={{
                                color: "#aeaeae",
                                fontSize: '24px',
                                padding: '8px',
                                '&.Mui-checked': {
                                    color: "#003300",
                                },
                            }}
                        />
                    }
                    label={
                    <div className={styles.itemName}>
                        {itemName}
                    </div>}
                />
            </div>
        );
    }
}

export { SelectMultipleCheckbox };